<c-form-field [control]="control" [showErrors]="showError" [focused]="isPickerOpen">
  @if (label) {
    <ion-label class="date-picker__label">{{ label }}</ion-label>
  }

  <div class="date-picker__box" cFieldBox>
    <button
      type="button"
      class="date-picker__icon"
      data-test-id="date-picker.open-button"
      [attr.aria-label]="'common.date-placeholder' | transloco"
      [disabled]="control.disabled"
      (click)="setPickerOpen(true)">
      <c-icon [icon]="faCalendar" />
    </button>

    <!-- One-way [value]: typed text is only parsed into the control once it's a complete DD/MM/YYYY date. -->
    <ion-input
      class="date-picker__field"
      inputmode="numeric"
      [value]="inputText"
      [placeholder]="placeholder"
      [disabled]="control.disabled"
      [maskito]="maskitoOptions"
      [maskitoElement]="maskitoPredicate"
      (ionInput)="onInputChange($any($event.target).value)"
      (ionBlur)="onTouched()" />

    @if (showClearButton && control.value) {
      <button
        type="button"
        class="date-picker__icon"
        [attr.aria-label]="'common.delete' | transloco"
        [disabled]="control.disabled"
        (click)="clearControlValue()">
        <c-icon [icon]="faXmark" />
      </button>
    }

    <button
      type="button"
      class="date-picker__icon"
      tabindex="-1"
      aria-hidden="true"
      [disabled]="control.disabled"
      (click)="setPickerOpen(true)">
      <c-icon [icon]="faChevronDown" />
    </button>
  </div>

  <c-field-message [helpText]="helpText" />
</c-form-field>

<ion-modal
  [isOpen]="isPickerOpen"
  (willPresent)="willPresentHandler()"
  (didPresent)="didPresentHandler()"
  (didDismiss)="setPickerOpen(false)"
  [breakpoints]="[0, 1]"
  [initialBreakpoint]="1"
  [handle]="false"
  class="auto-height-modal">
  <ng-template>
    <mbsc-datepicker
      display="inline"
      returnFormat="jsdate"
      [controls]="['calendar']"
      [firstDay]="1"
      [touchUi]="true"
      [min]="minDate"
      [max]="maxDate"
      [locale]="localeAll[currentLocale()]"
      [(ngModel)]="datePickerValue">
    </mbsc-datepicker>
    <div class="datepicker-buttons">
      <c-button
        type="ghost"
        [fullWidth]="false"
        (action)="cancelDatePicker()"
        data-test-id="datepicker.cancel-button">
        {{ 'common.cancel' | transloco }}
      </c-button>
      <div>
        @if (showClearButton) {
          <c-button type="ghost" [fullWidth]="false" (action)="clearSelectedDate()" data-test-id="datepicker.delete-button">
            {{ 'common.delete' | transloco }}
          </c-button>
        }
        <c-button type="ghost" [fullWidth]="false" (action)="confirmSelectedDate()" data-test-id="datepicker.ok-button">
          {{ 'common.ok' | transloco }}
        </c-button>
      </div>
    </div>
  </ng-template>
</ion-modal>
